import { render } from "./TabsComponent.vue?vue&type=template&id=70d55180&ts=true"
import script from "./TabsComponent.vue?vue&type=script&lang=ts"
export * from "./TabsComponent.vue?vue&type=script&lang=ts"

import "./scss/styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__